module.exports = __webpack_public_path__ + "media/stylesheets/images/userway_logo_images/us-sailing-3edbb14ea07a02e9804418c6111e9842.png";